import galvo from "@standard-library/galvo";
import clicker from "@standard-library/galvo-dom-clicker";
import { Kefir as K } from "kefir";

import dial from "./galvo/dial";

function arrows() {
  const element = document.createElement("div");
  const previous = clicker("paginator paginator--previous");
  const next = clicker("paginator paginator--next");

  element.appendChild(previous.element);
  element.appendChild(next.element);
  element.className = "paginators";

  return {
    element,
    next: next.click,
    previous: previous.click
  };
}

function intervalBetween(reset, duration) {
  return K.stream(emitter => {
    var intervalId = setInterval(() => emitter.emit(), duration);

    var subscription = reset.observe(() => {
      clearInterval(intervalId);

      intervalId = setInterval(() => emitter.emit(), duration);
    });

    return () => {
      subscription.unsubscribe();
      clearInterval(intervalId);
    };
  });
}

function slideshow({ slides, container, advance, start }) {
  const initial = start || K.never();
  const indicators = dial(slides.length);
  const click = K.fromEvents(container, "click");
  const index = K.merge([initial, indicators.index]).toProperty();
  const forward =
    advance || intervalBetween(K.merge([index.changes(), click]), 4000);
  const mechanism = galvo(
    {
      advance: K.merge([forward, click]),
      index: index
    },
    slides
  );

  indicators.highlight("is-active", mechanism.currentIndex);

  mechanism.current.observe(s => {
    s.classList.add("is-active");
  });

  mechanism.previous.observe(s => {
    s.classList.remove("is-active");
  });

  container.appendChild(indicators.element);

  return mechanism;
}

export default slideshow;



// WEBPACK FOOTER //
// ./app/javascript/packs/modules/slideshow.js